/**
 * Async Script Loader
 * Clean async loader replacing the original obfuscated version.
 * Deferred JS loading: activates on first user interaction or 9s after page load.
 *
 * Behavior (unchanged from original):
 * - Converts <script data-src="..."> → <script src="...">
 * - Converts <script type="text/javascripts"> → <script type="text/javascript">
 * - Fires CustomEvent('StartAsyncLoading') after 900ms delay
 * - Fires CustomEvent('startasyncloading') immediately
 * - Triggers on: scroll | mousemove | touchstart | 9s after window load
 */
(function () {
  var loaded = false;

  function loadAsync() {
    if (loaded) return;
    loaded = true;

    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      // Activate deferred scripts: copy data-src → src
      if (scripts[i].getAttribute('data-src') !== null) {
        scripts[i].setAttribute('src', scripts[i].getAttribute('data-src'));
        delete scripts[i].dataset.src;
      }

      // Re-create "text/javascripts" (intentional plural) as executable "text/javascript"
      if (scripts[i].getAttribute('type') === 'text/javascripts') {
        var el = document.createElement('script');
        for (var j = 0; j < scripts[i].attributes.length; j++) {
          var attr = scripts[i].attributes[j];
          el.setAttribute(attr.name, attr.value);
        }
        el.type = 'text/javascript';
        el.innerHTML = scripts[i].innerHTML;
        scripts[i].parentNode.removeChild(scripts[i]);
        scripts[i].parentNode.insertBefore(el, scripts[i]);
      }
    }

    // Fire async loading events (theme JS listens for these)
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
    }, 900);
    document.dispatchEvent(new CustomEvent('startasyncloading'));
  }

  // Trigger on first user interaction
  window.addEventListener('scroll', function () { loadAsync(); });
  window.addEventListener('mousemove', function () { loadAsync(); });
  window.addEventListener('touchstart', function () { loadAsync(); });

  // Fallback: trigger 9s after page load
  if (window.addEventListener) {
    window.addEventListener('load', function () {
      setTimeout(loadAsync, 9000);
    }, false);
  } else if (window.attachEvent) {
    window.attachEvent('onload', function () {
      setTimeout(loadAsync, 9000);
    });
  } else {
    window.onload = loadAsync;
  }
})();